module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/date-calc-777acdc1482d64ed77fffa0a031f4f39.png";